import React, { Fragment } from "react";

import { Box, TextField, makeStyles } from "@material-ui/core";

import { default as BaseModal } from "@ds-developer/modal";
import Button from "@ds-developer/button";

import { LessonNotesModalProps } from "./types";

const useStyles = makeStyles(theme => ({
  submitButton: {
    marginLeft: theme.spacing(2),
  },
}));

const LessonNotesModal: React.FC<LessonNotesModalProps> = ({
  value,
  open = false,
  handleSubmit,
  handleChange,
  handleCancel,
  handleDelete,
  handleNotes,
  submitting,
}) => {
  const classes = useStyles();

  const actions = (
    <Fragment>
      <Button
        variant="outlined"
        data-test="lesson-notes-modal-delete"
        onClick={handleDelete}
        disabled={submitting}
      >
        Delete note
      </Button>
      <Box display="flex">
        <Button
          variant="outlined"
          data-test="lesson-notes-modal-cancel"
          onClick={handleCancel}
          disabled={submitting}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          form="notesForm"
          data-test="lesson-notes-modal-save"
          className={classes.submitButton}
          disabled={submitting}
        >
          Save
        </Button>
      </Box>
    </Fragment>
  );

  return (
    <BaseModal
      actions={actions}
      open={open}
      title="Add instructor lesson notes"
    >
      <Fragment>
        <form id="notesForm" onSubmit={handleSubmit}>
          <TextField
            multiline
            rows={4}
            placeholder="Enter your notes here"
            fullWidth
            label="Lesson notes"
            name="notes"
            onChange={handleChange}
            value={value}
            variant="outlined"
            type="text"
            inputProps={{
              ["data-test"]: "lesson-notes-modal-input",
            }}
            onClick={handleNotes}
          />
        </form>
      </Fragment>
    </BaseModal>
  );
};

export default LessonNotesModal;
